import React, {useContext, Fragment, useEffect} from "react";
import {FormattedMessage} from "react-intl";

import TextInput from "../../Generic/textInput";
import UIPopupContext from "../../PageLayout/Popups/UIPopupContext";
import {accountNumberRegex, routingNumberRegex} from "./achConstants";

let copyErrorTimeOutId = null;

const ACHCredentialsPopupContent = () => {

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);

  const {accountNumber, routingNumber, accountNumberMatch, routingNumberMatch, inputFocused, allowMatchInputs,
    accountNumberTouched, routingNumberTouched, copyError} = uiPopupContext;

  const accountNumberIsCorrect = accountNumberRegex.test(accountNumber);
  const routingNumberIsCorrect = routingNumberRegex.test(routingNumber);
  const accountNumberMatchIsCorrect = accountNumber === accountNumberMatch;
  const routingNumberMatchIsCorrect = routingNumber === routingNumberMatch;

  const handleInputChange = (value, event) => {
    const accountPassed = event.target.id === "accountNumber"
      ? accountNumberRegex.test(value) && (accountNumberMatch === value)
      : event.target.id === "accountNumberMatch"
        ? accountNumber === value : accountNumberMatchIsCorrect;
    const routingPassed = event.target.id === "routingNumber"
      ? routingNumberRegex.test(value) && (routingNumberMatch === value)
      : event.target.id === "routingNumberMatch"
        ? routingNumber === value : routingNumberMatchIsCorrect;
    uiPopupDispatch({
      [event.target.id]: value,
      saveButtonDisabled: !accountPassed || !routingPassed,
      allowMatchInputs: true,
    });
  }

  const keyboardListener = (event) => {
    if ((event.ctrlKey || event.metaKey) && event.keyCode === 67
      && (event && event.target.value && event.target.id && event.target.name)) {
      event.preventDefault();
      uiPopupDispatch({copyError: event.target.id});
      copyErrorTimeOutId = setTimeout(() => {
        uiPopupDispatch({copyError: ""});
      }, 2000)
    }
  }

  useEffect(() => {
    document.addEventListener("keydown", keyboardListener);
    return () => {
      clearTimeout(copyErrorTimeOutId);
      document.removeEventListener("keydown", keyboardListener);
    }
  }, []);

  const handleInputFocus = (value, event) => {
    uiPopupDispatch({
      inputFocused: event.target.id,
      [event.target.id + "Touched"]: true,
    });
  }

  const handleInputBlur = () => {
    uiPopupDispatch({
      inputFocused: "",
      copyError: "",
    });
  }

  return (
    <div className="pl-2 pt-1 pr-2 flex-item flex flex--column">
      <div className="flex-item flex flex--center border-box text-left">
        <div className="pr-075">
          <label htmlFor="accountNumber" className="generic-popup-textbox-label">
            <FormattedMessage id="account.billingInformation.accountNumber"/>
          </label>
          <TextInput className={"generic-popup-textbox w-full m-0 radius-5 text-left"}
                     id="accountNumber"
                     name="accountNumber"
                     placeholder={""}
                     pattern="d{6,17}"
                     title="6 to 17 digit number"
                     value={accountNumber}
                     autoComplete="accountNumber"
                     onRealChange={handleInputChange}
                     onFocus={handleInputFocus}
                     onBlur={handleInputBlur}/>
          <p className="color-red3 font--12 h-075 line--12 m-0 ml-025 mt-025">
            {inputFocused === "accountNumber" || !accountNumber || accountNumberIsCorrect || !accountNumberTouched
              ? "" : "6 to 17 digit number"}
            {inputFocused === "accountNumber" && copyError === "accountNumber" ? "Copying is not allowed" : null}
          </p>
        </div>
        <div className="pl-075">
          <label htmlFor="routingNumber" className="generic-popup-textbox-label">
            <FormattedMessage id="account.billingInformation.routingNumber"/>
          </label>
          <TextInput className={"generic-popup-textbox w-full m-0 radius-5 text-left"}
                     id="routingNumber"
                     name="routingNumber"
                     placeholder={""}
                     title="9 digit number"
                     pattern="d{9}"
                     value={routingNumber}
                     autoComplete="routingNumber"
                     onRealChange={handleInputChange}
                     onFocus={handleInputFocus}
                     onBlur={handleInputBlur}/>
          <p className="color-red3 font--12 h-075 line--12 m-0 ml-025 mt-025">
            {inputFocused === "routingNumber" || !routingNumber || routingNumberIsCorrect || !routingNumberTouched
              ? "" : "9 digit number"}
            {inputFocused === "routingNumber" && copyError === "routingNumber" ? "Copying is not allowed" : null}
          </p>
        </div>
      </div>
      {accountNumberIsCorrect && routingNumberIsCorrect && allowMatchInputs ? (
        <Fragment>
          <p className="text-center secondary mt-0 mb-125">Please re-enter the information below:</p>
          <div className="flex-item flex flex--center border-box text-left">
            <div className="pr-075 w-full">
              <TextInput className={"generic-popup-textbox w-full m-0 radius-5 text-left"}
                         id="accountNumberMatch"
                         name="accountNumberMatch"
                         placeholder={""}
                         pattern="d{6,17}"
                         title="6 to 17 digit number"
                         value={accountNumberMatch}
                         autoComplete="off"
                         onRealChange={handleInputChange}
                         onFocus={handleInputFocus}
                         onBlur={handleInputBlur}/>
              <p className="color-red3 font--12 h-075 line--12 m-0 ml-025 mt-025">
                {inputFocused === "accountNumberMatch" || !accountNumberMatch || accountNumberMatchIsCorrect ? "" : "The entered value does not match."}
                {inputFocused === "accountNumberMatch" && copyError === "accountNumberMatch" ? "Copying is not allowed" : null}
              </p>
            </div>
            <div className="pl-075 w-full">
              <TextInput className={"generic-popup-textbox w-full m-0 radius-5 text-left"}
                         id="routingNumberMatch"
                         name="routingNumberMatch"
                         placeholder={""}
                         title="9 digit number"
                         pattern="d{9}"
                         value={routingNumberMatch}
                         autoComplete="off"
                         onRealChange={handleInputChange}
                         onFocus={handleInputFocus}
                         onBlur={handleInputBlur}/>
              <p className="color-red3 font--12 h-075 line--12 m-0 ml-025 mt-025">
                {inputFocused === "routingNumberMatch" || !routingNumberMatch || routingNumberMatchIsCorrect ? "" : "The entered value does not match."}
                {inputFocused === "routingNumberMatch" && copyError === "routingNumberMatch" ? "Copying is not allowed" : null}
              </p>
            </div>
          </div>
        </Fragment>
      ) : null}
    </div>
  )
}

export default ACHCredentialsPopupContent
